//Provider para Palestrantes
import { Injectable } from '@angular/core';
import { Http, Headers, BaseRequestOptions, RequestOptions, RequestMethod, Jsonp, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise'
import { Subject } from 'rxjs/Subject'

//Providers
import { ConfigProvider } from '../providers/config-provider';
import { UtilProvider } from '../providers/util-provider';

//Models
import { Url } from '../models/url.model';
import { Lecturer } from '../models/lecturer.model';


@Injectable()
export class LecturerProvider {

    public headers: Headers;
    public options: RequestOptions;
    public url = new Url;
    public params = new URLSearchParams();


    constructor(public http: Http, public jsonp: Jsonp, public configProvider: ConfigProvider, public utilProvider: UtilProvider) {
        this.url = configProvider.url;
        this.headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': this.url.SgunAuthorization, 'MobileReferer': this.url.SgunReferer });
        this.options = new RequestOptions({ headers: this.headers });

        this.params.set('format', 'json');
        this.params.set('callback', this.configProvider.CALLBACK);
    }


    getPalestrantes(congressoAno: number, usuarioGuid: string): Promise<Array<Lecturer>> {
        let param = this.params;
        param.set('congressoAno', <any>congressoAno);
        param.set('guidUsuario', <any>usuarioGuid);
        return this.jsonp.get(this.url.Cientifico + '/shared/apc/getPalestrantes.ashx', { search: param })
            .map(res => res.json()).toPromise()
            .then(data => {

                if (data && data.resposta.codigo == 0)
                    return data.resposta.retorno as Array<Lecturer>;

            });

    }

    adicionarPalestranteFavorito(usuarioGuid: string, palestrantesSgunIds:string) {
        let param = this.params;
        param.set('usuarioGuid', usuarioGuid);
        param.set('palestrantesSgunIds', <any>palestrantesSgunIds);


        return this.jsonp.get(this.url.Cientifico + '/shared/apc/adicionarPalestranteFavorito.ashx', { search: param })
            .map(res => res.json()).toPromise();

    }

    removerPalestranteFavorito(usuarioGuid: string, palestranteId: number) {
        let param = this.params;
        param.set('usuarioGuid', <any>usuarioGuid);
        param.set('palestranteId', <any>palestranteId);

        return this.jsonp.get(this.url.Cientifico + '/shared/apc/removerPalestranteFavorito.ashx', { search: param })
            .map(res => res.json()).toPromise();
    }

    getId(atividadeCadastroId: number, sgunId: number) {
        let param = this.params;
        param.set('atividadeCadastroId', <any>atividadeCadastroId);
        param.set('sgunId', <any>sgunId);

        return this.jsonp.get(this.url.Cientifico + '/shared/apc/getParticipanteId.ashx', { search: param })
            .map(res => res.json());
    }


    getAtividades(congressoAno: number, usuarioGuid: string, id: number): Promise<Array<any>> {
        let param = this.params;
        param.set('congressoAno', <any>congressoAno);
        param.set('guidUsuario', <any>usuarioGuid);
        param.set('sgunId', <any>id);
        return this.jsonp.get(this.url.Cientifico + '/shared/apc/getAtividadesByPalestrante.ashx', { search: param })
            .map(res => res.json()).toPromise()
            .then(data => {

                if (data && data.resposta.codigo == 0)
                    return data.resposta.retorno as Array<any>;

            });

    }


}



// WEBPACK FOOTER //
// ./src/providers/lecturer-provider.ts